"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Checkbox = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var CheckoxWrap_1 = require("./CheckoxWrap");
var index_1 = require("../index");
function Checkbox(props) {
    return (react_1.default.createElement(index_1.ThemeWrap, null,
        react_1.default.createElement(CheckoxWrap_1.CheckboxWrap, tslib_1.__assign({ disableRipple: true, color: "default", inputProps: { "aria-label": "decorative checkbox" } }, props))));
}
exports.Checkbox = Checkbox;
//# sourceMappingURL=index.js.map